import { jsx as _jsx } from "react/jsx-runtime";
import { ComponentSync, EditableDBItemV3 } from '@nu-art/thunderstorm-frontend';
import { ModuleFE_PathwayTransition } from '../../../../../../_entity/pathway-transition/ModuleFE_PathwayTransition.js';
import { DefaultEditor_InputText_Optional } from '@app/styles/frontend/ui-manager/ui-components';
// Inline, autosaving editor for a transition's label (state view, edit mode). Saving updates the shared
// transition cache, so the accordion cards and every other view refresh live via __onPathwayTransitionUpdated
// — no tab switch needed.
export class Renderer_TransitionLabelEditor extends ComponentSync {
    deriveStateFromProps(nextProps, state) {
        if (nextProps.transitionId !== state.transitionId) {
            state.transitionId = nextProps.transitionId;
            state.editable = this.generateEditableItem(nextProps.transitionId);
        }
        return state;
    }
    generateEditableItem(transitionId) {
        const transition = ModuleFE_PathwayTransition.cache.unique(transitionId);
        return new EditableDBItemV3(transition, ModuleFE_PathwayTransition)
            .setOnChanged(async () => this.forceUpdate())
            .setAutoSave(true);
    }
    render() {
        return _jsx(DefaultEditor_InputText_Optional, { editable: this.state.editable, prop: 'label', className: 'pathway-transition__label-input', placeholder: 'Transition label' });
    }
}
//# sourceMappingURL=Renderer_TransitionLabelEditor.js.map